import React from "react";
import { useAnnouncement } from "../../hooks/useAnnouncement";

function AnnouncementBar() {
  const ann = useAnnouncement();
  if (!ann || (!ann.text && !ann.image)) return null;
  return (
    <div className="ann-bar">
      {ann.image && (
        <img src={ann.image} alt="" className="ann-bar-img" onError={(e) => (e.currentTarget.style.display = "none")} />
      )}
      <div className="ann-bar-track">
        <div className="ann-bar-text">
          {ann.text} &nbsp; · &nbsp; {ann.text} &nbsp; · &nbsp; {ann.text}
        </div>
      </div>
    </div>
  );
}

export default AnnouncementBar;
